import { useTeamStore } from '#modules/team/stores/team.store.js';
import { computed } from 'vue';
import { useAuthStore } from '#modules/auth/stores/auth.store.js';

export const useAccountStatus = () => {
    const authStore = useAuthStore();
    const teamStore = useTeamStore();

    const hasFullAccess = computed(() => {
        return (
            authStore.isVerified &&
            teamStore.hasRequiredInformation &&
            teamStore.isVerified &&
            (teamStore.enforces2FA ? authStore.has2FA : true)
        );
    });

    const shouldEnforceTFA = computed(() => {
        return teamStore.enforces2FA && !authStore.has2FA;
    });

    return {
        hasFullAccess,
        shouldEnforceTFA,
    };
};
